import React from "react";
import { addElement } from "../../../actions/CreateSiteActions/createSiteActions";
import { connect } from "react-redux";
import {
  ADD_TITLE,
  ADD_PREFIX,
  ADD_FULL_TITLE,
  ADD_TREE_DIGIT_CODE,
  SET_PREFIX_VALID,
  SET_TITLE_VALID,
  SET_TREE_DIGIT_CODE_VALID,
  ADD_NAME,
} from "../../../actions/types";
import { validateTitle } from "./Validation/TitleValidation";
import { validatePrefix } from "./Validation/PrefixValidation";
import { validateTreeDigitCode } from "./Validation/TreeDigitCodeValidation";
import { updateValidationStatus } from "../../../actions/ValidationActions/validateStep2Acitons";
import RequiredTextField from "../../formFields/RequiredTextField";
import RequiredComboBox from "../../formFields/RequiredComboBox";
import InfoTooltip from "../../formFields/InfoTooltip";
import { Spinner, SpinnerSize } from "@fluentui/react";
import { validate } from "../../../actions/ValidationActions/serverValidation";
import { ComboBox } from "@fluentui/react";
import { PrefixOptions } from "../../../GlobalConst/globalEnums";

class Title extends React.Component {
  state = {
    isValidating: false,
    idgValidationNeeded: false,
    prefix: "",
    threeDigitCode: "",
  };

  // componentDidMount() {
  //     this.props.addTitle(ADD_NAME, this.props.localName);
  // }

  validate(value) {
    const error = validateTitle(value);
    this.props.updateValidationStatus(SET_TITLE_VALID, error);
  }

  validatePrefix(value) {
    const error = validatePrefix(value);
    this.props.updateValidationStatus(SET_PREFIX_VALID, error);
  }

  validateTreeDigitCode(value) {
    const error = validateTreeDigitCode(value);
    this.props.updateValidationStatus(SET_TREE_DIGIT_CODE_VALID, error);
  }

  onWriteEvent = (e, value) => {
    value = value.replace(/^\s*/, "");

    if (this.isIdgIntegration()) {
      this.setState({ idgValidationNeeded: true });
    }

    this.props.addTitle(ADD_TITLE, value);
    this.validate(value);
  };

  onChangeTreeDigitCode = (e, value) => {
    value = value.replace(/\D/g, "");

    if (value.length <= 3) {
      this.props.addTreeDigitCode(ADD_TREE_DIGIT_CODE, value);
    }

    this.validateTreeDigitCode(value);
  };
  generateNameFromTitle(title) {
    //var output = title.replace(/\s+(\w)?/gi, (match, letter) => {
    var output = title.trim().replace(/\s+(\S)/gi, (match, letter) => {
      //return letter ? letter.toUpperCase() : '';
      return letter;
    });

    return output.replace(/[^\w-]|^[-_]|[-_]$/g, "");
  }

  onBlurEvent = () => {
    if (this.props.localTitle) {
      const trimmedTitle = this.props.localTitle.trim();
      if (this.props.localTitle !== trimmedTitle) {
        this.props.addTitle(ADD_TITLE, trimmedTitle);
      }

      const fullTitle = this.generateFullTitle();

      if (fullTitle) {
        this.props.addTitle(ADD_FULL_TITLE, fullTitle);
        const name = this.generateNameFromTitle(fullTitle);
        this.props.addTitle(ADD_NAME, name);
      } else if (!this.props.localName) {
        const name = this.generateNameFromTitle(trimmedTitle);
        this.props.addTitle(ADD_NAME, name);
      }

      this.validateTitleInIDG(trimmedTitle);
    }
  };

  isIdgIntegration = () => {
    return (this.props.template.config || {}).idgIntegration;
  };

  validateTitleInIDG = (title) => {
    if (
      this.isIdgIntegration() &&
      this.state.idgValidationNeeded &&
      validateTitle(title).isValid
    ) {
      this.props.updateValidationStatus(SET_TITLE_VALID, { isValid: false });
      this.setState({ isValidating: true });

      var validationUrl = `/entryvalidation?title=${encodeURIComponent(
        title.trim()
      )}&templateId=${this.props.template.id}`;

      this.props.validate(validationUrl, SET_TITLE_VALID).then(() => {
        this.setState({ isValidating: false, idgValidationNeeded: false });
      });
    }
  };

  generateFullTitle = () => {
    // const { threeDigitCode } = this.state;
    const { localTitle, localPrefix, localTreeDigitCode } = this.props;
    const isComplete =
      localPrefix && /^\d{3}$/.test(localTreeDigitCode) && localTitle;
    return isComplete
      ? `${localPrefix}${localTreeDigitCode} ${localTitle}`
      : "";
  };

  handlePrefixChange = (event, option) => {
    this.validatePrefix(option.key);
    if (option) {
      this.props.addPrefix(ADD_PREFIX, option.key);

      // this.setState({ prefix: option.key });
    }
  };

  render() {
    const validatingSpinner = (
      <div title="Validating..." className="validation-spinner-withLabel">
        <Spinner size={SpinnerSize.medium} />
      </div>
    );

    const toolTipContent = (
      <span>
        Based on this Site address will be generated. It can be changed later in
        Site settings.
        <br />
        <br />
        Naming convention:
        <br />
        <a
          href="https://accelleronindustries.sharepoint.com/sites/DocHub/Public%20Documents/ITPO-0016%20-%20Information%20Classification%20and%20Handling%20Policy.pdf"
          // href="https://accelleronindustries.sharepoint.com/sites/ITTRAINING/Shared%20Documents/Forms/Reduced%20view.aspx?id=%2Fsites%2FITTRAINING%2FShared%20Documents%2FDigital%20workplace%20practices%2FNaming%20convention%20for%20MS%20Teams%20and%20SharePoint%20sites%2Epdf&parent=%2Fsites%2FITTRAINING%2FShared%20Documents%2FDigital%20workplace%20practices"
          target="_blank"
          rel="noopener noreferrer">
          ITPO-0016 - Information Classification and Handling Policy.pdf
        </a>
      </span>
    );
    const toolTipContentIATU = (
      <span>
        The project name must follow this convention:
        <br />
        <ul>
          <li>
            <b>"AA - Project name"</b>, where "AA" is the project type
          </li>
        </ul>
        Project types:
        <br />
        NP - New Product
        <br />
        CPI - Continuous Product Improvement
        <br />
        PD - Next Generation Product
        <br />
        PE - Product Enhancement
        <br />
        PM - Product Maintenence
        <br />
        TD - Technology Development
        <br />
        TS - Technology Scouting
        <br />
        MP - Manufacturing Development
        <br />
        TI - Method and Tool Development
        <br />
        TP - Product Scouting
      </span>
    );

    return (
      <div className="wizard-inside">
        <div className="item-title">
          {this.props.isIATU || this.props.isIAPCP
            ? "Project name"
            : "Display Name"}
          <InfoTooltip
            content={
              this.props.isIATU ||
              this.props.isIAPCP ||
              this.props.template.id === 6
                ? toolTipContentIATU
                : toolTipContent
            }
          />
        </div>
        {this.state.isValidating && validatingSpinner}
        <RequiredTextField
          name="Title"
          onChange={this.onWriteEvent}
          value={this.props.localTitle}
          validationResult={this.props.validationResult}
          onBlur={this.onBlurEvent}
        />
        {this.props.template.id === 6 && (
          <div>
            <div className="item-title-rdarchive">Choose right Prefix:</div>
            <RequiredComboBox
              name="Prefix"
              placeholder="Select a prefix"
              options={PrefixOptions}
              selectedKey={this.props.localPrefix}
              onChange={this.handlePrefixChange}
              onBlur={this.onBlurEvent}
            />

            <div className="item-title-rdarchive">Enter 3-digit number:</div>
            <RequiredTextField
              name="ThreeDigitCode"
              placeholder="123"
              // value={this.state.threeDigitCode}
              value={this.props.localTreeDigitCode}
              onChange={this.onChangeTreeDigitCode}
              // onChange={(e) => {
              //   const onlyDigits = e.target.value.replace(/\D/g, "");
              //   if (onlyDigits.length <= 3) {
              //     this.setState({ threeDigitCode: onlyDigits });
              //   }
              // }}
              maxLength={3}
              validationResult={this.props.validationResultTreeDigitCode}
              // validationResult={{
              //   isValid: /^\d{3}$/.test(this.state.threeDigitCode),
              //   message: "Must be exactly 3 digits",
              // }}
              onBlur={this.onBlurEvent}
            />

            {/* <div className="wizard-url">{`${this.state.prefix}${this.state.threeDigitCode} ${this.props.localTitle}`}</div> */}
            <div className="wizard-url">{`${this.props.localPrefix}${this.props.localTreeDigitCode} ${this.props.localTitle}`}</div>
          </div>
        )}
      </div>
    );
  }
}

const mapActionToProp = {
  addTitle: addElement,
  addPrefix: addElement,
  addTreeDigitCode: addElement,
  updateValidationStatus,
  validate,
};

const mapStateToProps = (state) => ({
  localTitle: state.newSite.Title,
  localName: state.newSite.Name,
  localPrefix: state.newSite.Prefix,
  localTreeDigitCode: state.newSite.TreeDigitCode,
  fullTitle: state.newSite.FullTitle,
  validationResult: state.step2Validation.TitleValid,
  validationResultTreeDigitCode: state.step2Validation.TreeDigitCodeValid,
  possibleWarning: state.wizard.nextStepRequested,
  isIATU: state.newSite.isIATU,
  isIAPCP: state.newSite.isIAPCP,
  template: state.newSite.Template,
});

export default connect(mapStateToProps, mapActionToProp)(Title);



// WEBPACK FOOTER //
// ./src/components/CreateSite/Step2/Title.js